<h2 mat-dialog-title>
  <mat-icon color="">bookmark</mat-icon>
  Fechas de Entrada y Salida
</h2>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="formGroup">

    <!-- Resumen general -->
    @if (getEntryDatesWithContracts().length > 0 || getExitDatesWithContracts().length > 0) {
      <div class="summary-section">
        <mat-divider></mat-divider>
        <div class="summary-content">
          <h4>Resumen</h4>
          <div class="summary-stats">
            <div class="stat-item entry-stat">
              <mat-icon>login</mat-icon>
              <span>Entradas: {{ getEntryDatesWithContracts().length }}</span>
            </div>
            <div class="stat-item exit-stat">
              <mat-icon>logout</mat-icon>
              <span>Salidas: {{ getExitDatesWithContracts().length }}</span>
            </div>
            <div class="stat-item total-stat">
              <mat-icon>assignment</mat-icon>
              <span>Total: {{ getEntryDatesWithContracts().length + getExitDatesWithContracts().length }}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <br>
      <div class="entry-exit-container">

        <!-- Sección de Fechas de Entrada -->
        <div class="entry-section">
          <h3>
            <mat-icon color="">login</mat-icon>
            Fechas de Entrada
          </h3>

          <!-- Formulario para agregar nueva fecha de entrada -->
          <div class="add-entry-form">
            <div class="form-row">
              <mat-form-field appearance="outline" class="contract-field">
                <mat-label>Contrato</mat-label>
                <mat-select formControlName="newEntryContract" [compareWith]="compareContracts">
                  @for (contract of activeContractList; track contract) {
                    <mat-option [value]="contract">
                      {{contract.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="date-field">
                <mat-label>Fecha de entrada</mat-label>
                <input matInput [matDatepicker]="entryPicker" formControlName="newEntryDate">
                <mat-datepicker-toggle matSuffix [for]="entryPicker"></mat-datepicker-toggle>
                <mat-datepicker #entryPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="folio-field">
                <mat-label>Número de folio</mat-label>
                <input matInput formControlName="newEntryFileNumber" placeholder="Ej: ENT-001-2024">
                <mat-icon matSuffix color="">receipt</mat-icon>
              </mat-form-field>

              <button mat-raised-button color="primary" type="button" (click)="addEntryDate()"
                class="add-button"
                [disabled]="!formGroup.get('newEntryContract')?.value || !formGroup.get('newEntryDate')?.value || !formGroup.get('newEntryFileNumber')?.value">
                <mat-icon>add</mat-icon>
                Agregar Entrada
              </button>
            </div>
          </div>

          <!-- Lista de fechas de entrada -->
          @if (getEntryDatesWithContracts().length > 0) {
            <div class="dates-list">
              <h4>Fechas de entrada registradas:</h4>
              <div class="date-items">
                @for (entryItem of getEntryDatesWithContracts(); track trackByEntryDate($index, entryItem)) {
                  <div
                    class="date-item entry-item">
                    <div class="date-info">
                      <div class="date-header">
                        <mat-icon color="">event</mat-icon>
                        <span class="date-text">{{ entryItem.date | date:'dd/MM/yyyy' }}</span>
                      </div>
                      <div class="contract-info">
                        <mat-icon color="">business</mat-icon>
                        <span class="contract-name">{{ entryItem.contractName }}</span>
                      </div>
                      <div class="folio-info">
                        <mat-icon color="">receipt</mat-icon>
                        <span class="folio-text">{{ entryItem.fileNumber }}</span>
                      </div>
                    </div>
                    <button mat-raised-button
                      (click)="openUpload(entryItem, 'upload', 'entry')"
                      matTooltip="Cargar documento de entrada">
                      <mat-icon>attach_file</mat-icon>
                    </button>
                    <button mat-raised-button
                      (click) = "openDownload(entryItem,'download')"
                      matTooltip = "Ver documento de entrada"
                      [disabled] = "!entryItem.pdf">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button color="warn"
                      (click)="removeEntryDate(entryItem.contract, entryItem.date)"
                      matTooltip="Eliminar fecha de entrada"
                      class="delete-btn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Mensaje cuando no hay fechas de entrada -->
          @if (getEntryDatesWithContracts().length === 0) {
            <div class="no-dates-message">
              <mat-icon color="">info</mat-icon>
              <span>No hay fechas de entrada registradas</span>
            </div>
          }
        </div>

        <mat-divider [vertical]="true" class="section-divider"></mat-divider>

        <!-- Sección de Fechas de Salida -->
        <div class="exit-section">
          <h3>
            <mat-icon color="">logout</mat-icon>
            Fechas de Salida
          </h3>

          <!-- Formulario para agregar nueva fecha de salida -->
          <div class="add-exit-form">
            <div class="form-row">
              <mat-form-field appearance="outline" class="contract-field">
                <mat-label>Contrato</mat-label>
                <mat-select formControlName="newExitContract" [compareWith]="compareContracts">
                  @for (contract of activeContractList; track contract) {
                    <mat-option [value]="contract">
                      {{contract.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="date-field">
                <mat-label>Fecha de salida</mat-label>
                <input matInput [matDatepicker]="exitPicker" formControlName="newExitDate">
                <mat-datepicker-toggle matSuffix [for]="exitPicker"></mat-datepicker-toggle>
                <mat-datepicker #exitPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="folio-field">
                <mat-label>Número de folio</mat-label>
                <input matInput formControlName="newExitFileNumber" placeholder="Ej: SAL-001-2024">
                <mat-icon matSuffix color="">receipt</mat-icon>
              </mat-form-field>

              <button mat-raised-button color="accent" type="button" (click)="addExitDate()"
                class="add-button"
                [disabled]="!formGroup.get('newExitContract')?.value || !formGroup.get('newExitDate')?.value || !formGroup.get('newExitFileNumber')?.value">
                <mat-icon>add</mat-icon>
                Agregar Salida
              </button>
            </div>
          </div>

          <!-- Lista de fechas de salida -->
          @if (getExitDatesWithContracts().length > 0) {
            <div class="dates-list">
              <h4>Fechas de salida registradas:</h4>
              <div class="date-items">
                @for (exitItem of getExitDatesWithContracts(); track trackByExitDate($index, exitItem)) {
                  <div
                    class="date-item exit-item">
                    <div class="date-info">
                      <div class="date-header">
                        <mat-icon color="">event</mat-icon>
                        <span class="date-text">{{ exitItem.date | date:'dd/MM/yyyy' }}</span>
                      </div>
                      <div class="contract-info">
                        <mat-icon color="">business</mat-icon>
                        <span class="contract-name">{{ exitItem.contractName }}</span>
                      </div>
                      <div class="folio-info">
                        <mat-icon color="">receipt</mat-icon>
                        <span class="folio-text">{{ exitItem.fileNumber }}</span>
                      </div>
                    </div>
                    <button mat-raised-button
                      (click)="openUpload(exitItem, 'upload', 'exit')"
                      matTooltip="Cargar documento de salida">
                      <mat-icon>attach_file</mat-icon>
                    </button>
                    <button mat-raised-button
                      (click) = "openDownload(exitItem,'download')"
                      matTooltip = "Ver documento de salida"
                      [disabled] = "!entryItem.pdf">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button color="warn"
                      (click)="removeExitDate(exitItem.contract, exitItem.date)"
                      matTooltip="Eliminar fecha de salida"
                      class="delete-btn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Mensaje cuando no hay fechas de salida -->
          @if (getExitDatesWithContracts().length === 0) {
            <div class="no-dates-message">
              <mat-icon color="">info</mat-icon>
              <span>No hay fechas de salida registradas</span>
            </div>
          }
        </div>

      </div>



    </form>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="warn">Cancelar</button>
    <button mat-raised-button color="primary" (click)="update()">Guardar</button>
  </mat-dialog-actions>